import React, { useContext, useEffect, useState } from "react";
import CreditOrder from "./CreditOrder";
import Analytics from "./Analytics";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AssetGateway from "./AssetGateway";
import Credit from "./Credit";
import AnalyzerItems from "./AnalyzerItems";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import GatewayItems from "./GatewayItems";
import { LuRefreshCw } from "react-icons/lu";
import axios from "axios";
import RefreshFundsModal from "./RefreshFundsModal";
import KycLookup from "./KycLookup";
import { IoChevronDown } from "react-icons/io5";
import { sideBarContext } from "../../App";

function IndividualDetails() {
  const [filter, setFilter] = useState("creditOrder");
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const message = searchParams.get("name");
  const creditTypeOd = searchParams.get("od");
  const lenderID = localStorage.getItem("lender_uuid");
  const analyzerOptions = [
    "Stock",
    "Mutual Fund",
    "Bank Account Statement",
    "Vehicle",
    "Real Estate",
  ];
  const gatewayOptions = ["Reports", "Consent Summary History"];

  const [analyzerType, setAnalyzerType] = useState("Stock");
  const [gatewayType, setGatewayType] = useState("Reports");
  const [openAnalyzer, setOpenAnalyzer] = useState(false);
  const [openAssetGateway, setOpenAssetGateway] = useState(false);

  const [closePopupFirst, setClosePopupFirst] = useState(true);
  const [singleOrderView, setSingleOrderView] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [refreshRender, setRefreshRender] = useState(false);
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const [refreshStatus, setRefreshStatus] = useState(false);
  const [responseMessage, setresponseMessage] = useState("");
  const divRef = React.useRef(null);
  const buttonRef = React.useRef(null);
  const { expanded } = useContext(sideBarContext);

  const [openScaledDown, setOpenScaledDown] = useState(false);
  const refreshFunds = async () => {
    setImageLoading(true);
    setShowRefreshModal(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users/${id}/periodic_aa_data_fetch`,
        options
      );
      if (res.status === 200) {
        setRefreshStatus(true);
        setresponseMessage(res.data.response);
        setRefreshRender(!refreshRender);
      }

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
      if (
        error.response.data.response === null ||
        error.response.data.response === undefined
      ) {
        setresponseMessage("Something went wrong, Please try again later");
      } else {
        setresponseMessage(error.response.data.response);
      }

      setRefreshStatus(false);
    } finally {
      setImageLoading(false);
    }
  };
  useEffect(() => {
    // Add event listener when component is mounted
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up the event listener when the component is unmounted
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (buttonRef.current && buttonRef.current.contains(event.target)) {
      return;
    }
    if (divRef.current && !divRef.current.contains(event.target)) {
      setOpenScaledDown(false); // Close the div when clicking outside
    }
  };

  return (
    <div
      className={`bg-[#f1f1f6] ${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } min-h-[100vh] max-h-full`}
    >
      <div
        className={`w-full bg-[#f1f1f6] px-[16px] pt-[16px] pb-4 ${
          singleOrderView === true ? "h-full" : "h-[100vh]"
        }`}
        onClick={() => {
          if (closePopupFirst) {
            setOpenAnalyzer(false);
          } else if (!closePopupFirst && openAnalyzer) {
            setOpenAnalyzer(false);
          }
        }}
      >
        <div className=" w-full bg-white h-[57px] rounded-lg p-4">
          <p className=" text-xl font-semibold">Individuals</p>
        </div>
        <div className=" w-full bg-white px-4 mt-4 pt-[12px] rounded-lg relative">
          <p className=" text-sm flex items-center">
            <span
              className="cursor-pointer hover:underline transition ease-in-out duration-500 hover:font-medium"
              onClick={() => navigate("../../assets")}
            >
              {" "}
              List of Users{" "}
            </span>
            <span className=" font-bold text-base text-[#262626]">
              {" "}
              &gt; {message || "---"}{" "}
            </span>
            <button
              ref={buttonRef}
              onClick={() => setOpenScaledDown(!openScaledDown)}
              className=" border rounded-[2px] border-[#6f6f6f] h-4 w-4 ml-2 flex justify-center items-center"
            >
              <IoChevronDown color="#6f6f6f" size={12} />
            </button>
          </p>
          <div className=" w-full flex justify-between items-center">
            <div className=" text-sm  space-x-8 mt-2">
              {" "}
              <button
                className={`   ${
                  filter === "creditOrder"
                    ? "border-b-[3px] border-[#212b36]  font-semibold "
                    : ""
                }   py-[4px]`}
                onClick={() => {
                  setFilter("creditOrder");
                  setOpenAnalyzer(false);
                  setOpenAssetGateway(false);
                  setClosePopupFirst(true);
                  setSingleOrderView(false);
                }}
              >
                Credit Order
              </button>
              <button
                className={` ] ${
                  filter === "analytics"
                    ? "border-b-[3px] border-[#212b36]  font-semibold"
                    : ""
                }   py-[4px]`}
                onClick={() => {
                  setFilter("analytics");
                  setOpenAnalyzer(false);
                  setOpenAssetGateway(false);
                  setClosePopupFirst(true);

                  setSingleOrderView(false);
                }}
              >
                Net Worth
              </button>
              <button
                className={`${
                  filter === "analyzer"
                    ? "border-b-[3px] border-[#212b36]  font-semibold"
                    : ""
                } py-[4px]`}
                onClick={() => {
                  setOpenAssetGateway(false);
                  if (filter !== "analyzer") {
                    setFilter("analyzer");
                    setSingleOrderView(false);
                    setClosePopupFirst(false);
                  } else {
                    setFilter("analyzer");
                    setSingleOrderView(false);
                    setOpenAnalyzer(!openAnalyzer);
                  }
                }}
              >
                <div className="flex flex-row justify-center items-center">
                  <span>Analyzer : {analyzerType}</span>
                  {openAnalyzer ? (
                    <IoMdArrowDropup size={"20px"} color="#262626" />
                  ) : (
                    <IoMdArrowDropdown size={"20px"} color="#262626" />
                  )}
                </div>
              </button>
              <button
                className={`${
                  filter === "assetGateway"
                    ? "border-b-[3px] border-[#212b36]  font-semibold"
                    : ""
                } py-[4px]`}
                onClick={() => {
                  setOpenAnalyzer(false);
                  if (filter !== "assetGateway") {
                    setFilter("assetGateway");
                    setSingleOrderView(false);
                  } else {
                    setOpenAssetGateway(!openAssetGateway);
                    setSingleOrderView(false);
                  }
                }}
              >
                <div className="flex flex-row justify-center items-center">
                  <span>Asset Gateway : {gatewayType}</span>
                  {openAssetGateway ? (
                    <IoMdArrowDropup size={"20px"} color="#262626" />
                  ) : (
                    <IoMdArrowDropdown size={"20px"} color="#262626" />
                  )}
                </div>
              </button>
            </div>
            {/* {filter === "assetGateway" && gatewayType === "Reports" && (
              <button
                onClick={refreshFunds}
                className=" flex items-center   bg-[#00394d] text-white rounded px-2 py-1 text-xs h-[28px] mb-1 "
              >
                <LuRefreshCw />

                <span className=" ml-2"> Refresh User Data</span>
              </button>
            )} */}
          </div>
          {openAnalyzer && filter === "analyzer" && (
            <div className="absolute bg-white text-[#262626] p-2 rounded-lg inset-x-48 w-fit shadow-lg mt-1 z-50">
              <div className="flex flex-row justify-center items-center gap-3">
                {analyzerOptions.map((item) => {
                  return (
                    <p
                      className={`px-4 py-2 cursor-pointer text-xs font-semibold text-[#262626] rounded-md ${
                        analyzerType === item ? "bg-[#A0FF77]" : "bg-white"
                      }`}
                      onClick={() => {
                        setAnalyzerType(item);
                        setOpenAnalyzer(false);
                      }}
                    >
                      {item}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
          {openAssetGateway && filter === "assetGateway" && (
            <div className="absolute bg-white text-[#262626] p-2 rounded-lg inset-x-[340px] w-fit shadow-lg mt-1">
              <div className="flex flex-row justify-center items-center gap-3">
                {gatewayOptions.map((item) => {
                  return (
                    <p
                      className={`px-4 py-2 cursor-pointer text-xs font-semibold text-[#262626] rounded-md ${
                        gatewayType === item ? "bg-[#A0FF77]" : "bg-white"
                      }`}
                      onClick={() => {
                        setGatewayType(item);
                        setOpenAssetGateway(false);
                      }}
                    >
                      {item}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
          {openScaledDown && (
            <div
              ref={divRef}
              className=" absolute w-[450px] h-[370px] pb-4  rounded-lg shadow-lg bg-white overflow-y-auto -top-5 left-[122px]  scale-[0.7] z-30 flex justify-center"
            >
              <KycLookup />{" "}
            </div>
          )}
        </div>
        {filter === "analytics" && <Analytics id={id} />}
        {filter === "creditOrder" && (
          <Credit
            creditTypeOd={creditTypeOd}
            singleOrderView={singleOrderView}
            setSingleOrderView={setSingleOrderView}
          />
        )}
        {filter === "analyzer" && <AnalyzerItems flag={analyzerType} id={id} />}
        {filter === "assetGateway" && (
          <GatewayItems
            id={id}
            flag={gatewayType}
            refreshRender={refreshRender}
          />
        )}
        {showRefreshModal && (
          <RefreshFundsModal
            setShowRefreshModal={setShowRefreshModal}
            loading={imageLoading}
            refreshStatus={refreshStatus}
            message={responseMessage}
          />
        )}
      </div>
    </div>
  );
}

export default IndividualDetails;
